import * as types from './types'

export default {
  [types.MUTATE_COMPETENCES_SEARCH_RESULT]: (state, payload) => {
    state.competencesSearchResult = payload
  },
  [types.MUTATE_CLOSING_EXCEPTIONS_SEARCH_RESULT]: (state, payload) => {
    state.closingExceptionsSearchResult = payload
  },
  [types.MUTATE_CURRENT_COMPETENCE]: (state, payload) => {
    state.currentCompetence = payload
  },
  [types.MUTATE_CLOSING_EXCEPTION_CATEGORIES]: (state, payload) => {
    state.closingExceptionCategories = payload || []
  },
}
